'use client'

import { EmailDraftView } from '@/components/email/EmailDraftView'
import { Icons } from '@/components/ui/icons'
import type { EmailDraft } from '@/lib/email-draft'

interface EmailDraftCardProps {
  draft: EmailDraft
  vendor?: string
}

/**
 * In-chat email-draft card rendered by the AI Manager when the `draft_email`
 * tool returns a draft. Wraps the shared EmailDraftView (Edit + Approve & Send).
 */
export function EmailDraftCard({ draft, vendor }: EmailDraftCardProps) {
  return (
    <div className="mt-1 w-full rounded-2xl border border-brand-cornflower/30 bg-white p-4 shadow-soft">
      <div className="mb-3 flex items-center gap-2">
        <div className="flex h-7 w-7 items-center justify-center rounded-lg bg-brand-navy/5">
          <Icons.mail className="h-4 w-4 text-brand-navy" />
        </div>
        <div>
          <p className="text-sm font-semibold text-brand-navy">Email draft</p>
          {vendor && (
            <p className="text-[11px] text-muted-foreground">{vendor}</p>
          )}
        </div>
      </div>
      <EmailDraftView draft={draft} />
    </div>
  )
}
